import { PersonAdd as PersonAddIcon } from '../../components/ui';
import './AddUserCard.css';

interface AddUserCardProps {
  onClick: () => void;
}

export const AddUserCard: React.FC<AddUserCardProps> = ({ onClick }) => {
  return (
    <div className="add-user-card" onClick={onClick}>
      <div className="add-user-card__icon">
        <PersonAddIcon sx={{ fontSize: 32 }} />
      </div>

      <h3 className="add-user-card__title">Add New User</h3>

      <p className="add-user-card__subtitle">
        Create a new team member account
      </p>
    </div>
  );
};
